var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.slug)?_c('blog-article',{attrs:{"slug":_vm.$route.params.slug}}):_c('blog-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }